<p>add-ink works!</p>
<div class="container-fluid">
    <div class="row justify-content-center mt-5">
      <div class="col-lg-7">
        <div class="card">
          <div class="card-body">
            <div *ngIf="!showOrderForm; else formView">
              <form [formGroup]="orderForm">
                <div class="mb-3">
                  <label for="clientName">Client</label>
                  <select formControlName="clientName" class="form-control">
                    <option value="" disabled>Select Client</option>
                    <option *ngFor="let client of clientList" [value]="client._id">{{ client.clientName }}</option>
                  </select>
                </div>
                <div class="mb-3">
                  <label for="orderOption">Option</label>
                  <select formControlName="orderOption" class="form-control">
                    <option value="" disabled>Select Process</option>
                    <!-- <option value="newJob">New Job</option>
                    <option value="existingJob">Existing Job</option> -->
                    <option value="newJob">Add Ink </option>
                    <option value="existingJob">Add Production</option>

                  </select>
                </div>
                <div class="text-end">
                  <button type="button" class="btn btn-danger" (click)="NewJob()" [disabled]="!orderForm.valid">
                    Next
                  </button>
                </div>
              </form>
            </div>
            <ng-template #formView>
              
              <div *ngIf="orderForm.get('orderOption').value === 'newJob'; else existingJobForm">
                <!-- Your form for newJob... -->
                <form [formGroup]="addOrderForm" (ngSubmit)="addInk()">
                  <div class="col-md-12 mb-3"> <label class="form-label">Client Name</label> <input type="text"
                    class="form-control" formControlName="clientName" [value]="selectedClient?.clientName" readonly>
                </div>
                <div class="col-md-12 mb-3"> <label for="ticketno" class="form-label">Ticket No</label> <input type="text"
                    formControlName="ticketno" id="ticketno" class="form-control" readonly /> </div>
                <div class="col-md-12 mb-3"> <label for="inkName" class="form-label">Ink Name</label> <input type="text"
                    formControlName="inkName" id="inkName" class="form-control" /> </div>
                <div class="col-md-12 mb-3"> <label for="inkColor" class="form-label">Ink Color</label> <input type="text"
                    formControlName="inkColor" id="inkColor" class="form-control" /> </div>
                <!-- <div class="col-md-12 mb-3"> <label for="jobName" class="form-label">Job Name</label> <input type="text"
                    formControlName="jobName" id="jobName" class="form-control" /> </div> -->
                <div class="col-md-12 mb-3"> <label for="jobType" class="form-label">Job Type</label>
                  <div class="input-group"> <select formControlName="jobType" id="jobType" class="form-control minimal">
                      <option value="Fresh">Fresh</option>
                      <option value="Mixed">Mixed</option>
                    </select> </div>
                </div>
                <div class="col-md-12 mb-3"> <label for="issue" class="form-label">Issue</label> <input type="text"
                    formControlName="issue" id="issue" class="form-control" /> </div>
                    <div class="col-md-12 mb-3"> <label for="return" class="form-label">Return</label> <input type="text"
                        formControlName="return" id="return" class="form-control" /> </div>
                <!-- <div class="col-md-12 mb-3"> <label for="fdOption" class="form-label">FD Option</label>
                  <div class="input-group"> <select formControlName="fdOption" id="fdOption"
                      class="form-control custom-select minimal">
                      <option value="EMRS">EMRS</option>
                      <option value="EMLS">EMLS</option>
                      <option value="Readable">Readable</option>
                      <option value="Non-Readable">Non-Readable</option>
                      <option value="Any Direction">Any Direction</option>
                      <option value="Direction not Required">Direction not Required</option>
                    </select> </div>
                </div> -->
                <div class="col-md-12 text-end"> 
                  <button type="submit" class="btn btn-info">Submit</button> 
                  <button type="button" class="btn btn-secondary ms-2" (click)="toggleView()">Cancel</button>
                </div>
                </form>



                <div class="table-responsive">
                  <table class="table table-bordered red-border text-center">
                    <thead>
                      <tr>
                        <th>DownTime</th>
                        <th>Time (Seconds)</th>
                        <th>DownTime Remarks</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let entry of materialMixEntries">
          
                        <td>{{ entry.clientName || 'N/A' }}</td>
                        <td>{{ entry.jobName || 'N/A' }}</td>
                        <td>{{ entry.orderKgs || 'N/A' }}</td>
            
                        <td>
                          <!-- <button type="button" class="btn btn-outline-danger btn-sm" >
                            <i class="feather icon-trash-2 text-danger"></i> Delete
                          </button> -->
                        </td>
                      </tr>
                      
                    </tbody>
                  </table>
                </div>

              </div>
              <ng-template #existingJobForm>
            
  
                <div class="card">
                  <div class="card-body">
                    <!-- <div class="mb-4 d-md-flex align-items-center justify-content-between">
                      <div>
                        <h4>Client Name: {{ ClientName }}</h4>
                        <p>Attaching Recipe to Job:  {{ JobName }}</p>
                      </div>
                    </div> -->
                    <div class="row">
                      <div class="col-md-12">
                        <!-- <form [formGroup]="addMaterialForm" (ngSubmit)="addMaterialForm()" class="ng-pristine ng-valid"> -->
                          <form [formGroup]="addMaterialForm" class="ng-pristine ng-valid">
                          <div class="row">
                            <div class="col form-group mb-3">
                              <label class="form-label">Client Name</label>
                              <select class="form-select" formControlName="clientName" required>
                                <option value="" disabled>Select Client</option>
                                <option *ngFor="let client of clientList" [value]="client.clientName">{{ client.clientName }}</option>
                              </select>
                            </div>
                            <div class="col form-group mb-3">
                              <label class="form-label">Job Name</label>
                              <select class="form-select" formControlName="jobName" required>
                                <option value="" disabled>Select Job Name</option>
                                <option *ngFor="let job of jobList" [value]="job">{{ job }}</option>
                              </select>
                            </div>
                            <div class="col form-group mb-3">
                              <label class="form-label">Selected Materials</label>
                              <select class="form-select" formControlName="process" [(ngModel)]="selectedProcess" (change)="onProcessSelect($event.target.value)">
                                <option value="" disabled>Select Material</option>
                                <option *ngFor="let process of selectedMaterials" [value]="process">{{ process }}</option>
                              </select>
                            
                          </div>
                          </div>
                          <p>Material Mixing for Purchase Order: 0 || Kgs: 500</p>
                          <div class="row">
                            <div class="col form-group mb-3">
                              <label class="form-label">Material</label>
                              <select class="form-select" formControlName="material" [(ngModel)]="selectedMaterial" (change)="onMaterialSelect($event.target.value)">
                                <option value="" disabled>Select Material</option>
                                <option *ngFor="let material of materialOptions" [value]="material">{{ material }}</option>
                              </select>
                          </div>
                          
                            <div class="col form-group mb-3">
                              <label class="form-label">rollNo</label>
                              <input type="number" class="form-control" formControlName="rollNo" placeholder="rollNo" />
                            </div>
                            <div class="col form-group mb-3">
                              <label class="form-label">weight </label>
                              <input type="text" class="form-control" formControlName="weight" placeholder="Weight" />
                            </div>
                            <div class="col form-group mb-3">
                              <label class="form-label">return </label>
                              <input type="text" class="form-control" formControlName="return" placeholder="return" />
                            </div>
                            <!-- <div class="col-auto mt-4">
                              <button type="submit" class="btn btn-outline-danger" (click)="addMaterial()">Add Material</button>
                            </div> -->
                          </div>
                
                
                
                
                          <h5 _ngcontent-thg-c101="" class="danger-text">Production Output Records</h5>
                          <div class="row">
                            <!-- <div class="col form-group mb-3">
                              <label class="form-label">Material</label>
                              <select class="form-select" formControlName="material" [(ngModel)]="selectedMaterial" (change)="onMaterialSelect($event.target.value)">
                                <option value="" disabled>Select Material</option>
                                <option *ngFor="let material of materialOptions" [value]="material">{{ material }}</option>
                              </select>
                          </div> -->
                          
                            <!-- <div class="col form-group mb-3">
                              <label class="form-label">Roll No</label>
                              <input type="number" class="form-control" formControlName="outputRollNo" placeholder="rollNo" />
                            </div> -->
                            <div class="col form-group mb-3">
                              <label class="form-label">Output Kgs </label>
                              <input type="text" class="form-control" formControlName="outputKgs" placeholder="output kgs" />
                            </div>
                            <div class="col form-group mb-3">
                              <label class="form-label">Waste Kgs</label>
                              <input type="text" class="form-control" formControlName="wasteKgs" placeholder="Waste Kgs" />
                            </div>
                            <div class="col form-group mb-3">
                                <label class="form-label">Flag</label>
                                <input type="text" class="form-control" formControlName="flag" placeholder="flag" />
                              </div>
                            <div class="col-auto mt-4">
                              <button type="submit" class="btn btn-outline-danger" (click)="addMaterial()">Save Data</button>
                            </div>
                          </div>

                          <div class="col-auto mt-2 offset-md-9">
                            <!-- Button with similar functionality -->
                            <button type="button" class="btn btn-outline-danger" (click)="handleButtonClick()">Capture Breakdown</button>
                          </div>
                
                
                
                        </form>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Form to be displayed when the button is clicked -->
<div *ngIf="showForm" class="card">
  <!-- Your form HTML here -->
  <h1 class=" mt-2 mb-2 text-center font-bold font-up danger-text">Breakdown Details</h1>

  <div class="card">
    <div class="card-body">
      <div class="ng-star-inserted">
        <div class="row">
          <div class="col-md-12 ng-star-inserted">
            <!-- <h5 class="text-center font-bold font-up danger-text">Breakdown Details</h5> -->
            <form [formGroup]="addBreakdownDetailForm" class="ng-untouched ng-pristine ng-valid">
                <div class="row">
                  <div class="col-3 col form-group mb-3">
                      <label class="form-label">DownTime</label>
                      <select class="form-select" formControlName="downTime" required>
                        <option value="DownTime" disabled>DownTime</option>
                        <option value="Breakdown">Breakdown</option>
                        <option value="JCO">JCO</option>
                        <option value="Cylinder Clean">Cylinder Clean</option>
                        <option value="D/B Change">D/B Change</option>
                        <option value="Splice Fail">Splice Fail</option>
                        <option value="Power Fail">Power Fail</option>
                        <option value="AW Approval">AW Approval</option>
                        <option value="Shade Approval">Shade Approval</option>
                <option value="No Operator">No Operator</option>
                        <option value="Maintenance">Maintenance</option>
                 <option value="Material Shortage">Material Shortage</option>
                      </select>
                    </div>
                    
                    <div class="col-3 col form-group mb-3">
                        <label for="time" class="form-label">Time (Seconds)</label>
                        <input type="text" formControlName="time" id="time"
                            class="form-control"/>
                    </div>

                    <div class="col-3 col form-group mb-3">
                      <label for="downTimeRemarks" class="form-label">DownTime Remarks</label>
                      <input type="text" formControlName="downTimeRemarks" id="downTimeRemarks"
                          class="form-control"/>
                  </div>
                </div>
           

            <div class="row">
              <div class="col-auto col-lg-12 col-md-6 col-xl-6 offset-md-5">
                <!-- <button type="submit" class="btn btn-outline-success" (click)="viewJob()">Add Ink Data</button> -->
                <button type="submit" class="btn btn-outline-danger" (click)="addBreakdown()" >Submit</button>
              </div>
            </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- breakdown data table -->
  <div class="card mb-4">
    <div class="card-body">
  
      <div class="row">
        <!-- Grid column -->
        <div class="col-md-12">
          <div class="row">
          </div>
        </div>
        <!-- Grid column -->
      </div>
      <!-- Grid row -->
      <div class="table-responsive">
        <table class="table table-bordered red-border text-center">
          <thead>
            <tr>
              <th>DownTime</th>
              <th>Time (Seconds)</th>
              <th>DownTime Remarks</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let entry of paginatedEntries; let i = index">

              <td>{{ entry.matArray[0].downTime }}</td>
              <td>{{ entry.matArray[0].time }}</td>
              <td>{{ entry.matArray[0].downTimeRemarks }}</td>
  
              <td>
                <button type="button" class="btn btn-outline-danger btn-sm" >
                  <i class="feather icon-trash-2 text-danger"></i> Delete
                </button>
              </td>
            </tr>
            
          </tbody>
        </table>
      </div>
      <div class="pagination-container">
        <div class="pagination mt-3 d-flex justify-content-between align-items-center">
          <div>
            <p>Showing {{ calculateRangeStart() }} - {{ calculateRangeEnd() }} of {{ materialMixEntries.length }}</p>
          </div>
      
          <div class="d-flex">
            <a class="pagination-btn pt-2" (click)="onPageChange(currentPage - 1)" [ngClass]="{'disabled': currentPage === 1}">
              <i class="feather icon-chevrons-left"></i>
            </a>
            <ng-container *ngFor="let page of getNumberRangeMatMix(ceilValue(materialMixEntries.length / itemsPerPage))">
              <a class="pagination-circle" [class.active]="currentPage === page" (click)="onPageChange(page)">
                {{ page }}
              </a>
              <span *ngIf="page < ceil(materialMixEntries.length / itemsPerPage)" class="page-number-space"></span>
            </ng-container>
            <a class="pagination-btn pt-2" (click)="onPageChange(currentPage + 1)" [ngClass]="{'disabled': currentPage === ceilValue(materialMixEntries.length / itemsPerPage)}">
  
              <i class="feather icon-chevrons-right"></i>
            </a>
          </div>
        </div>
      </div>
      
    </div>
  </div>
</div>
<!-- breakdown table end -->








                
                <div class="card mb-4">
                  <div class="card-body">
                
                    <div class="row">
                      <!-- Grid column -->
                      <div class="col-md-12">
                        <div class="row">
                          <div class="col-md-10">
                            <h3 class="text-center font-bold font-up danger-text">
                              Client Name: {{ ClientName }} <br> Jobname:  {{ JobName }}
                              <!-- Jobname: LXM0025 Boss Baker Chocolate Hazelnut 72565 ----||----Total Mat Req for this Job: 785.4469273743 -->
                            </h3>
                          </div>
                          <!-- <div class="col-md-2">
                            <a  class="btn btn-outline-dark btn-sm active" role="button" aria-pressed="true" (click)="saveAndContinue()">Save &
                              Continue</a>
                          </div> -->
                        </div>
                      </div>
                      <!-- Grid column -->
                    </div>
                    <!-- Grid row -->
                    <div class="table-responsive">
                      <table class="table table-bordered red-border text-center">
                        <thead>
                          <tr>
                            <th>P.O No.</th>
                            <th>Material</th>
                            <th>Input Kgs</th>
                            <th>return</th>
                
                            <th>Roll ID</th>
                            <th>Ref No.</th>
                            <th>Output Kgs</th>
                            <th>Output Waste</th>
                           
                           
                            <th>Flag</th>
                
                            <th>Order No</th>
                           
                            <!-- <th>Mat_Required</th>
                            <th>Action</th> -->
                          </tr>
                        </thead>
                        <tbody>
                          <tr *ngFor="let entry of paginatedMaterialMixEntries; let i = index">
                            <td>0</td>
                            <td>{{ entry.matArray[0].materialMix}}</td>
                            <td>{{ entry.matArray[0].weight }}</td>
                            <td>{{ entry.matArray[0].return }}</td>
                
                            <td>{{ entry.matArray[0].rollNo }}</td>
                            <td>LXM0487</td>
                            <!-- <td>{{ entry.matArray[0]?.materialMix?.name }}</td> -->
                
                            <td>{{ entry.matArray[0].outputKgs }}</td>
                            <td>{{ entry.matArray[0].wasteKgs }}</td>
                         
                           
                            <td>{{ entry.matArray[0].flag}}</td>
                            <td>order</td>
                           
                            <!-- <td>{{ entry.matArray[0].matRequired }}</td>
                
                            <td>
                              <button type="button" routerLink="#" class="btn btn-outline-success btn-sm" (click)="calculateMatRequired(i)">
                                <i class="feather icon-dollar-sign "></i> Calc MatReq
                              </button>
                              <button type="button" class="btn btn-outline-danger btn-sm" (click)="deleteMaterialMix(i)">
                                <i class="feather icon-trash-2 text-danger"></i> Delete
                              </button>
                            </td> -->
                          </tr>
                          
                        </tbody>
                      </table>
                    </div>
                    <div class="pagination-container">
                      <div class="pagination mt-3 d-flex justify-content-between align-items-center">
                        <div>
                          <p>Showing {{ calculateRangeStart() }} - {{ calculateRangeEnd() }} of {{ materialMixEntries.length }}</p>
                        </div>
                    
                        <div class="d-flex">
                          <a class="pagination-btn pt-2" (click)="onPageChange(currentPage - 1)" [ngClass]="{'disabled': currentPage === 1}">
                            <i class="feather icon-chevrons-left"></i>
                          </a>
                          <ng-container *ngFor="let page of getNumberRangeMatMix(ceilValue(materialMixEntries.length / itemsPerPage))">
                            <a class="pagination-circle" [class.active]="currentPage === page" (click)="onPageChange(page)">
                              {{ page }}
                            </a>
                            <span *ngIf="page < ceil(materialMixEntries.length / itemsPerPage)" class="page-number-space"></span>
                          </ng-container>
                          <a class="pagination-btn pt-2" (click)="onPageChange(currentPage + 1)" [ngClass]="{'disabled': currentPage === ceilValue(materialMixEntries.length / itemsPerPage)}">
                
                            <i class="feather icon-chevrons-right"></i>
                          </a>
                        </div>
                      </div>
                    </div>
                    
                  </div>
                </div>
                
              </ng-template>
              
             
            </ng-template>
          </div>
        </div>
      </div>
    </div>
  </div>






















  
  